import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';
import FilterField from 'components/fields/FilterField';
import IconMail from 'components/icons/IconMail';

import ShareEmailFormField from './ShareEmailFormField';

const styles = theme => ({
  fieldArray: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    position: 'relative',
    padding: '1px 6px 2px 10px',
    border: `1px solid ${theme.palette.primary.A100}`,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[100],
  },
  fieldArrayActive: {
    borderColor: theme.palette.primary[500],
  },
  fieldArrayError: {
    borderColor: theme.palette.validation[500],
  },
  filterField: {
    margin: 4,
  },
  iconMail: {
    width: 20,
    height: 16,
    margin: '8px 12px 0 6px',
    color: theme.palette.primary.A100,
  },
});

class ShareEmailFormFieldArray extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      hovered: false,
      blurred: true,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.onFieldArrayClick = this.onFieldArrayClick.bind(this);
    this.onFieldArrayMouseOver = this.onFieldArrayMouseOver.bind(this);
    this.onFieldArrayMouseOut = this.onFieldArrayMouseOut.bind(this);
    this.onFilterFieldFocus = this.onFilterFieldFocus.bind(this);
    this.onFilterFieldBlur = this.onFilterFieldBlur.bind(this);
  }

  onInputChange() {
    if (this.state.blurred === true) {
      this.setState({ blurred: false });
    }
  }

  onInputKeyDown(event) {
    const { fields, meta } = this.props;
    if (['Enter', ' '].indexOf(event.key) !== -1 && meta.valid) {
      fields.push('');
      setTimeout(() => {
        this.inputRef.focus();
      }, 100);
    }
  }

  onInputFocus() {
    this.setState({ active: true });
  }

  onInputBlur() {
    this.setState({
      active: false,
      blurred: true,
    });
  }

  onFieldArrayClick(event) {
    if (event.target === this.fieldArrayRef) {
      this.inputRef.focus();
    }
  }

  onFieldArrayMouseOver() {
    this.setState({ hovered: true });
  }

  onFieldArrayMouseOut() {
    this.setState({ hovered: false });
  }

  onFilterFieldFocus() {
    this.setState({ active: true });
  }

  onFilterFieldBlur() {
    this.setState({ active: false });
  }

  render() {
    const { fields, meta, fullWidth, placeholder, errorPlacement, classes } = this.props;
    const { active, hovered, blurred } = this.state;
    const errorVisible =
      (Boolean(meta.dirty) || Boolean(meta.submitFailed))
      && Boolean(meta.error)
      && (active || hovered);
    return (
      <FormControl fullWidth={fullWidth}>
        <Tooltip
          content={
            meta.error ? (
              <Typography variant="subheading" color="secondary">
                {meta.error}
              </Typography>
            ) : ' '
          }
          open={errorVisible}
          placement={errorPlacement}
          color="white"
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <div
            role="presentation"
            className={classNames(classes.fieldArray, {
              [classes.fieldArrayActive]: active,
              [classes.fieldArrayError]: (meta.dirty || meta.submitFailed) && meta.error && blurred,
            })}
            onClick={this.onFieldArrayClick}
            onMouseOver={this.onFieldArrayMouseOver}
            onMouseOut={this.onFieldArrayMouseOut}
            ref={(fieldArrayRef) => { this.fieldArrayRef = fieldArrayRef; }}
          >
            <IconMail className={classes.iconMail} />
            {fields.map((field, index) => (
              <Field
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                name={field}
                {...index === fields.length - 1 ? {
                  component: ShareEmailFormField,
                  onChange: this.onInputChange,
                  onKeyDown: this.onInputKeyDown,
                  onFocus: this.onInputFocus,
                  onBlur: this.onInputBlur,
                  placeholder,
                  inputRef: (inputRef) => { this.inputRef = inputRef; },
                } : {
                  component: FilterField,
                  className: classes.filterField,
                  size: 'sm',
                  format: value => ({ label: value }),
                  onDelete: () => {
                    fields.remove(index);
                    setTimeout(() => {
                      this.inputRef.focus();
                    }, 100);
                  },
                  onChipFocus: this.onFilterFieldFocus,
                  onChipBlur: this.onFilterFieldBlur,
                }}
              />
            ))}
          </div>
        </Tooltip>
      </FormControl>
    );
  }
}

ShareEmailFormFieldArray.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    valid: PropTypes.bool.isRequired,
  }).isRequired,
  fullWidth: PropTypes.bool,
  placeholder: PropTypes.string,
  errorPlacement: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
  classes: PropTypes.shape({
    fieldArray: PropTypes.string.isRequired,
    fieldArrayActive: PropTypes.string.isRequired,
    fieldArrayError: PropTypes.string.isRequired,
    filterField: PropTypes.string.isRequired,
    iconMail: PropTypes.string.isRequired,
  }).isRequired,
};

ShareEmailFormFieldArray.defaultProps = {
  fullWidth: false,
  placeholder: '',
  errorPlacement: 'right',
};

export default withStyles(styles)(ShareEmailFormFieldArray);



// WEBPACK FOOTER //
// ./src/components/common/ShareDialog/ShareEmailFormFieldArray.js